import usNumberValidator from 'utils/helpers/usNumberValidator';
export var requiredMessage = 'This field is required to close ticket as resolved';
export var numericMessage = 'Enter a non-negative numeric value, e.g. 0, 0.1 or 100';
export var rules = {
    email: [{ type: 'email', message: 'Please enter a correct email' }],
    phone: [
        {
            validator: usNumberValidator,
            message: 'Please enter a correct phone number'
        }
    ],
    number: [
        { pattern: /^(?:\d*)$/, message: 'Value should contain just number' },
        { max: 5, message: 'Value should be less than 5 characters' }
    ],
    inherit: []
};
export var surveyRules = [
    {
        required: true,
        message: requiredMessage
    }
];
var NON_NEGATIVE_DECIMAL_REGEX = /^\d+(\.\d+)?$/;
export var numericRule = {
    validator: function (_, value) {
        if (value == null || value === '')
            return Promise.resolve();
        return NON_NEGATIVE_DECIMAL_REGEX.test(String(value))
            ? Promise.resolve()
            : Promise.reject(new Error(numericMessage));
    }
};
export var getValidNumericValue = function (value) {
    if (value === '' || !NON_NEGATIVE_DECIMAL_REGEX.test(value))
        return null;
    return value;
};
export var getFormInitialValues = function (answers) {
    return answers.reduce(function (acc, a) {
        acc[a.id] = a.answer_value;
        return acc;
    }, {});
};
